console.log('CUSTOM');



let $w = $(window),
    $nav = $('.header--bottom-row'),
    $topoffset = $('.header--bottom-row').offset().top;

$w.scroll(function() {
  if($w.scrollTop() > $topoffset) {
  	$nav.addClass('sticky');
  } else {
    $nav.removeClass('sticky');
  }
});

